module.exports = __webpack_public_path__ + "img/77_37.daf56aef.png";